import {AxiosInstance} from "axios";
import API from "../../utils/api";
import {AuthModel} from "../../models/auth/auth.model";

export class AuthService {

    api: AxiosInstance = API;

    auth(username: string, password: string): Promise<AuthModel> {
        return this.api.post<AuthModel>('auth/login_check', {username, password}).then(x => x.data);
    }
}

export const authService = new AuthService();
